/** Comparación flexible de teléfonos CRM (Perú y E.164). */

export function digitsOnly(s: string): string {
  return s.replace(/\D/g, '');
}

export function phonesMatch(a: string | null | undefined, b: string | null | undefined): boolean {
  if (!a?.trim() || !b?.trim()) return false;
  const da = digitsOnly(a);
  const db = digitsOnly(b);
  if (da.length >= 9 && db.length >= 9) return da.slice(-9) === db.slice(-9);
  return da === db;
}
